import { getStatisticsApi, getUserLocationsApi } from 'redux/apis/Dashboard';
import { fetchError, fetchStart, fetchSuccess, postSuccess } from './Common';

export const GET_STATISTICS_SUCCESSFUL = 'GET_STATISTICS_SUCCESSFUL';
export function getStatistics(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getStatisticsApi(data)
        .then(res => {
          console.log("GOT RESPONSE OF STATS")
          dispatch({
            type: GET_STATISTICS_SUCCESSFUL,
            payload: res,
          });
          dispatch(fetchSuccess());
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError());
          reject(err);
        });
    });
  };
}

export const GET_USER_STATS_SUCCESS = 'GET_USER_STATS_SUCCESS';
export function getUserStats(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getStatisticsApi(data)
        .then(res => {
          dispatch({
            type: GET_USER_STATS_SUCCESS,
            payload: res,
          });
          dispatch(fetchSuccess());
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError());
          reject(err);
        });
    });
  };
}

export const GET_USER_LOCATIONS_SUCCESS = 'GET_USER_LOCATIONS_SUCCESS';
export function getUsesLocations(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getUserLocationsApi(data)
        .then(res => {
          dispatch({
            type: GET_USER_LOCATIONS_SUCCESS,
            payload: res,
          });
          dispatch(fetchSuccess());
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError());
          reject(err);
        });
    });
  };
}
